import ListItem from "@/components/ListItem";
import { Event } from "../../../types";
import SectionHeading from "@/components/SectionHeading";
import Banner from "@/components/Banner";
import { isPAT } from "../../../utils";

interface EventDetailsProps {
  eventData?: Event;
}

export const EventDetailsSection = ({ eventData }: EventDetailsProps) => {
  const isStatusPending = eventData?.status === "Pending";
  const isPayoutSubmitted = !!eventData?.patEventAttributes?.submittedForPaymentAt;
  const shouldShowBanner = isStatusPending && !isPayoutSubmitted && isPAT(eventData);

  return (
    <>
      {shouldShowBanner && (
        <Banner
          description="The Section must complete and submit this Payouts tab to notify Finance and ensure payment to the host, examiner, and Section."
          variant="info"
          inline={true}
          className="mt-8"
        />
      )}
      <SectionHeading heading="Event Details" />
      <ListItem headline={eventData?.section?.name} iconName="domain" overline="Section" iconBackground={true} />
      <div className="mt-6">
        <ListItem
          headline={eventData?.registrationCount?.toString()}
          iconName="group"
          overline="Registrants"
          iconBackground={true}
        />
      </div>
    </>
  );
};
